import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsOutList, goodsOutCreate, goodsOutUpdate, deleteGoodsOut, goodsOutFind, goodsOutSubmit, goodsOutCheck, getGoodsList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'BianlidianGoodsOut',
  components: {},
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])),
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd');
      } else {
        return '';
      }
    },
    formatDateTime: function formatDateTime(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsOutList,
      type: '',
      loading: false,
      multipleSelection: [],
      goodsLoading: false,
      goodsOptions: [],
      dialogVisible: false,
      goodsOutDetailTableData: [],
      spuNo: '',
      formData: {
        sellerId: '',
        goodsOutNo: '',
        remark: '',
        auditStatus: '',
        auditRemark: ''
      },
      addRules: {
        sellerId: [{
          required: true,
          message: '请选择便利店',
          trigger: 'blur'
        }]
      },
      submitRules: {
        remark: [{
          required: true,
          message: '请输入调拨说明',
          trigger: 'blur'
        }]
      },
      auditRules: {
        auditRemark: [{
          required: true,
          message: '请输入审核意见',
          trigger: 'blur'
        }],
        auditStatus: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('goodsout init');

                _this.onSubmit();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.loading = true;
      this.getTableData();
      this.loading = false;
    },
    onReset: function onReset() {
      debugger;
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 输入调整数
    onInputOutNum: function onInputOutNum(row) {
      debugger;

      if (!isNaN(row.goodsOutNum)) {
        row.goodsOutAmount = (parseInt(row.goodsOutNum) * parseFloat(row.goodsCost)).toFixed(2);
      } else {
        row.goodsOutAmount = 0;
      }
    },
    // 新增调整
    onAdd: function onAdd() {
      var that = this;
      that.dialogVisible = true;
      that.type = 'add';
    },
    // 商品库搜索
    goodsSearch: function goodsSearch(query) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this3;
                that.handleGoodsSearch(query, '', function (res, isExit, queryName, goodsNo) {
                  debugger; // 默认添加

                  if (isExit && queryName === 'goodsNo') {
                    that.handleAddGoodsIn(that.goodsOptions[0]);
                    that.spuNo = '';
                    that.$refs.goodsSearchSelect.blur();
                    setTimeout(function () {
                      that.$refs.goodsSearchSelect.focus();
                    }, 50);
                  } // 扫条形码，不存在


                  if (!isExit && queryName === 'goodsNo') {
                    that.$message({
                      type: 'warning',
                      message: '商品不存在，请尝试根据名称搜索'
                    });
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleGoodsSearch: function handleGoodsSearch(query, queryName, fn) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, param, result, isExit;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('handleGoodsSearch:' + queryName);
                that = _this4;

                if (!(query === '')) {
                  _context5.next = 5;
                  break;
                }

                that.goodsOptions = [];
                return _context5.abrupt("return");

              case 5:
                that.goodsOptions = [];
                that.goodsLoading = true;
                param = {};

                if (queryName && queryName === 'goodsName') {
                  param.goodsName = query;
                } else if (queryName && queryName === 'goodsNo') {
                  param.goodsNo = query;
                } else if (isNaN(query)) {
                  param.goodsName = query;
                  queryName = 'goodsName';
                } else {
                  param.goodsNo = query;
                  queryName = 'goodsNo';
                }

                _context5.next = 11;
                return getGoodsList({
                  'goodsNo': param.goodsNo,
                  'goodsName': param.goodsName,
                  'sellerId': that.formData.sellerId,
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 11:
                result = _context5.sent;
                that.goodsLoading = false;
                debugger; // 存在

                isExit = false;

                if (result.data.list && result.data.list.length > 0) {
                  isExit = true; // 扫条形码

                  if (param.goodsNo) {
                    result.data.list.forEach(function (item) {
                      that.goodsOptions.push({
                        'sellerId': item.sellerId,
                        'goodsName': item.goodsName,
                        'spuNo': item.spuNo,
                        'goodsNo': param.goodsNo,
                        'goodsStock': item.goodsStock,
                        'goodsCost': item.goodsLatestCost,
                        'goodsOutNum': 0,
                        'goodsOutAmount': 0,
                        'categoryNo': item.categoryNo,
                        'categoryName': item.categoryName,
                        'supplierNo': item.supplierNo,
                        'supplierName': item.supplierName,
                        'goodsUnit': item.goodsUnit,
                        'goodsSpecification': item.goodsSpecification,
                        'remark': ''
                      });
                    });
                  } // 名称搜索


                  if (param.goodsName) {
                    result.data.list.forEach(function (item) {
                      that.goodsOptions.push({
                        'sellerId': item.sellerId,
                        'goodsName': item.goodsName,
                        'spuNo': item.spuNo,
                        'goodsNo': item.goodsNo,
                        // 名称搜索接口不反查条形码
                        'goodsStock': item.goodsStock,
                        'goodsCost': item.goodsLatestCost,
                        'goodsOutNum': 0,
                        'goodsOutAmount': 0,
                        'categoryNo': item.categoryNo,
                        'categoryName': item.categoryName,
                        'supplierNo': item.supplierNo,
                        'supplierName': item.supplierName,
                        'goodsUnit': item.goodsUnit,
                        'goodsSpecification': item.goodsSpecification,
                        'remark': ''
                      });
                    });
                  }
                }

                if (fn) {
                  fn(result.data.list && result.data.list.length > 0 ? result.data.list : [], isExit, queryName, param.goodsNo);
                }

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 选中便利店商品
    onGoodsSel: function onGoodsSel() {
      debugger;
      var that = this;

      if (that.formData.sellerId === '') {
        that.$message({
          type: 'warning',
          message: '请选择便利店'
        });
        return;
      }

      var goods = this.goodsOptions.filter(function (item) {
        // eslint-disable-next-line eqeqeq
        return that.spuNo == item.spuNo;
      });

      if (goods.length > 0) {
        that.handleAddGoodsIn(goods[0]);
        that.spuNo = '';
      }
    },
    // 删除商品
    onDelGoods: function onDelGoods(row) {
      var that = this;
      that.goodsOutDetailTableData = that.goodsOutDetailTableData.filter(function (item) {
        return item.spuNo != row.spuNo;
      });
    },
    // 添加调整明细
    handleAddGoodsIn: function handleAddGoodsIn(goods) {
      var that = this;
      var isExit = false;
      that.goodsOutDetailTableData.forEach(function (item) {
        // eslint-disable-next-line eqeqeq
        if (goods.spuNo == item.spuNo) {
          isExit = true;
        }
      });

      if (!isExit) {
        that.goodsOutDetailTableData.splice(that.goodsOutDetailTableData.length, 0, JSON.parse(JSON.stringify(goods)));
      }
    },
    // 变更
    onUpdate: function onUpdate(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this5;
                _context6.next = 3;
                return goodsOutFind({
                  'goodsOutNo': row.goodsOutNo,
                  'sellerId': row.sellerId
                });

              case 3:
                res = _context6.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  res.data.list.forEach(function (item) {
                    item.goodsCost = item.goodsLatestCost;
                  });
                  that.goodsOutDetailTableData = res.data.list;
                }

                debugger;
                _this5.type = 'update';
                _this5.dialogVisible = true;
                that.formData.sellerId = row.sellerId;
                that.formData.goodsOutNo = row.goodsOutNo;

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 双击查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.handelView(row);
    },
    // 查看
    onView: function onView(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this6;
                that.handelView(row);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handelView: function handelView(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this7;
                _context8.next = 3;
                return goodsOutFind({
                  'goodsOutNo': row.goodsOutNo,
                  'sellerId': row.sellerId
                });

              case 3:
                res = _context8.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  res.data.list.forEach(function (item) {
                    item.goodsCost = item.goodsLatestCost;
                  });
                  that.goodsOutDetailTableData = res.data.list;
                }

                _this7.type = 'view';
                _this7.dialogVisible = true;
                _this7.formData.auditStatus = row.auditStatus + '';
                _this7.formData.auditRemark = row.auditRemark;
                _this7.formData.remark = row.remark;

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 提审
    onSubmitAudit: function onSubmitAudit(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                that = _this8;
                _context9.next = 3;
                return goodsOutFind({
                  'goodsOutNo': row.goodsOutNo,
                  'sellerId': row.sellerId
                });

              case 3:
                res = _context9.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  res.data.list.forEach(function (item) {
                    item.goodsCost = item.goodsLatestCost;
                  });
                  that.goodsOutDetailTableData = res.data.list;
                }

                _this8.type = 'submit';
                _this8.dialogVisible = true;
                _this8.formData.sellerId = row.sellerId;
                _this8.formData.goodsOutNo = row.goodsOutNo;
                _this8.formData.remark = row.remark;

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 审核
    onAudit: function onAudit(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                that = _this9;
                _context10.next = 3;
                return goodsOutFind({
                  'goodsOutNo': row.goodsOutNo,
                  'sellerId': row.sellerId
                });

              case 3:
                res = _context10.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  res.data.list.forEach(function (item) {
                    item.goodsCost = item.goodsLatestCost;
                  });
                  that.goodsOutDetailTableData = res.data.list;
                  that.formData.goodsOutNo = row.goodsOutNo;
                  that.formData.sellerId = row.sellerId;
                }

                _this9.type = 'audit';
                _this9.dialogVisible = true;
                _this9.formData.remark = row.remark;

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteGoodsOut({
          'sellerId': row.sellerId,
          'goodsOutNo': row.goodsOutNo
        }).then(function (res) {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.getTableData();
          } // eslint-disable-next-line handle-callback-err

        }, function (err) {});
      }).catch(function (err) {});
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.goodsOptions = [];
      this.goodsOutDetailTableData = [];
      this.type = '';
      this.spuNo = '';
      this.formData = {
        sellerId: '',
        goodsOutNo: '',
        remark: '',
        auditStatus: '',
        auditRemark: ''
      };
    },
    onDialogSubmit: function onDialogSubmit() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this10;
                debugger;
                _context11.t0 = that.type;
                _context11.next = _context11.t0 === 'add' ? 5 : _context11.t0 === 'update' ? 7 : _context11.t0 === 'submit' ? 9 : _context11.t0 === 'audit' ? 11 : _context11.t0 === 'view' ? 13 : 15;
                break;

              case 5:
                that.handelAdd();
                return _context11.abrupt("break", 16);

              case 7:
                that.handelUpdate();
                return _context11.abrupt("break", 16);

              case 9:
                that.handelSubmit();
                return _context11.abrupt("break", 16);

              case 11:
                that.handelAudit();
                return _context11.abrupt("break", 16);

              case 13:
                that.closeDialog();
                return _context11.abrupt("break", 16);

              case 15:
                return _context11.abrupt("break", 16);

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handelAdd: function handelAdd() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var that;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                that = _this11;
                debugger;
                that.$refs['addForm'].validate(function (valid) {
                  if (that.goodsOutDetailTableData.length === 0) {
                    that.$message({
                      type: 'warning',
                      message: '请添加需要调整的商品'
                    });
                    return;
                  }

                  if (valid) {
                    goodsOutCreate({
                      'sellerId': parseInt(that.formData.sellerId),
                      'remark': that.formData.remark,
                      'list': that.goodsOutDetailTableData
                    }).then(function (res) {
                      if (res.code === 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    // 变更保存
    handelUpdate: function handelUpdate() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this12;
                that.$refs['addForm'].validate(function (valid) {
                  if (that.goodsOutDetailTableData.length === 0) {
                    that.$message({
                      type: 'warning',
                      message: '请添加需要调整的商品'
                    });
                    return;
                  }

                  goodsOutUpdate({
                    'sellerId': parseInt(that.formData.sellerId),
                    'goodsOutNo': that.formData.goodsOutNo,
                    'remark': that.formData.remark,
                    'list': that.goodsOutDetailTableData
                  }).then(function (res) {
                    if (res.code === 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                });

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    // 提交保存
    handelSubmit: function handelSubmit() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var that;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                that = _this13;
                debugger;
                that.$refs['submitForm'].validate(function (valid) {
                  if (valid) {
                    goodsOutSubmit({
                      'sellerId': that.formData.sellerId,
                      'goodsOutNo': that.formData.goodsOutNo,
                      'remark': that.formData.remark
                    }).then(function (res) {
                      // eslint-disable-next-line eqeqeq
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      } // eslint-disable-next-line handle-callback-err

                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    // 审核保存
    handelAudit: function handelAudit() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var that;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                that = _this14;
                debugger;
                that.$refs['auditForm'].validate(function (valid) {
                  if (valid) {
                    goodsOutCheck({
                      'sellerId': that.formData.sellerId,
                      'goodsOutNo': that.formData.goodsOutNo,
                      'auditStatus': parseInt(that.formData.auditStatus),
                      'auditRemark': that.formData.auditRemark
                    }).then(function (res) {
                      // eslint-disable-next-line eqeqeq
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      } // eslint-disable-next-line handle-callback-err

                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    }
  }
};